export default __webpack_public_path__ + "static/media/data-point-icon.47da6a25.svg";